export const ADD_REVIEWS = 'ADD_REVIEWS'
export const ADD_REVIEW = 'ADD_REVIEW'
export const REVIEWS_FAILED = 'REVIEWS_FAILED'
export const REVIEWS_LOADING = 'REVIEWS_LOADING'
export const UPDATE_REVIEW = 'UPDATE_REVIEW'
export const DELETE_REVIEW = 'DELETE_REVIEW'

export const ADD_USER = 'ADD_USER'
export const USER_LOGIN_FAILED = 'USER_LOGIN_FAILED'
export const CLEAR_USER = 'CLEAR_USER'

export const ADD_COMPANY = 'ADD_COMPANY'
export const COMPANY_LOGIN_FAILED = 'COMPANY_LOGIN_FAILED'
export const CLEAR_COMPANY = 'CLEAR_COMPANY'

export const ADD_PRODUCTS = 'ADD_PRODUCTS'
export const ADD_PRODUCT = 'ADD_PRODUCT'
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT'
export const PRODUCTS_FAILED = 'PRODUCTS_FAILED'
export const PRODUCTS_LOADING = 'PRODUCTS_LOADING'
